import {
  generateLanguageQuery,
  optionalI18nString,
  optionalImage,
  optionalQuery,
  resourcesArray,
  tipsArray
} from '@/services/dataStore/queries/fragments'

const stickerProjection = `
  'withBack': withBack.asset->url,
  'peeling': peeling.asset->url,
  'noBack': noBack.asset->url,
  'altText': ${generateLanguageQuery('altText')},
`

const pairingsMappingQuery = `*[_type == 'remedyRemedy' && baseRemedy._ref == ^._id || pairedRemedy._ref == ^._id] {
  'baseRemedy': baseRemedy._ref,
  'pairedRemedy': pairedRemedy._ref,
  'pairingDescriptionI18n': ${generateLanguageQuery('pairingDescription')}
}`

const remedyProjection = (isReferenceArticle: boolean) => `
  'key': _id,
  'nameI18n': ${generateLanguageQuery('name')},
  'descriptionI18n': ${generateLanguageQuery('description')},
  footprint,
  ${optionalQuery('footprintPlacement', true)},
  footprintShape,
  offsiteCollecting,
  sortOrder,
  ${optionalQuery('capacity', false)},
  'stickerImg': sticker->{${stickerProjection}},
  'deprecated': deprecated == true,
  'budgets': costs[] {
    'key': category._ref,
    'cost': value,
  },
  'category': category._ref,
  'effects': *[_type == 'remedyEffect' && remedy._ref == ^._id] {
    'key': effect._ref,
    'level': sign + level
  },
  ${
    isReferenceArticle
      ? `
        ${optionalI18nString('descriptionLong', 'longDescriptionI18n')},
        ${optionalI18nString('costSummary', 'costSummaryI18n')},
        ${optionalImage('hero')},
        ${tipsArray},
        ${resourcesArray},
        'pairings': ${pairingsMappingQuery}`
      : ``
  }
`

export const remediesQuery = () =>
  `*[_type == "remedy"] {
    ${remedyProjection(false)}
  }`

export const remedyReferenceQuery = (
  remedyKey: string
) => `*[_type == "remedy" && _id == "${remedyKey}"] {
    ${remedyProjection(true)}
  }`
